import {
  cancelInvoicePayment,
  getInvoicePaymentStatus,
  getFacilityInvoices,
  getOpenInvoicePayment,
  getPendingInvoiceForFacility,
  initiateInvoicePayment,
} from "../webclients/payment.client";
import {
  FacilityInvoice,
  InvoiceSummary,
  OpenPaymentIntent,
  PageResponse,
  PaymentInitiatedResponse,
  PaymentStatusResponse,
} from "../types/payment";

export const paymentApi = {
  getPendingInvoice: async (facilityId: number): Promise<InvoiceSummary> => {
    const response = await getPendingInvoiceForFacility(facilityId);
    return response.data;
  },

  getFacilityInvoices: async (
    facilityId: number,
    page: number,
    size: number
  ): Promise<PageResponse<FacilityInvoice>> => {
    const response = await getFacilityInvoices(facilityId, page, size);
    return response.data;
  },

  initiateInvoicePayment: async (
    invoiceId: number,
    idempotencyKey: string
  ): Promise<PaymentInitiatedResponse> => {
    const response = await initiateInvoicePayment(invoiceId, idempotencyKey);
    return response.data;
  },

  getInvoicePaymentStatus: async (
    invoiceId: number,
    paymentIntentId: number
  ): Promise<PaymentStatusResponse> => {
    const response = await getInvoicePaymentStatus(invoiceId, paymentIntentId);
    return response.data;
  },

  // Resolves null when there is nothing to resume (HTTP 204, empty body).
  getOpenInvoicePayment: async (invoiceId: number): Promise<OpenPaymentIntent | null> => {
    const response = await getOpenInvoicePayment(invoiceId);
    if (response.status === 204 || !response.data) return null;
    return response.data;
  },

  cancelInvoicePayment: async (
    invoiceId: number,
    paymentIntentId: number
  ): Promise<PaymentStatusResponse> => {
    const response = await cancelInvoicePayment(invoiceId, paymentIntentId);
    return response.data;
  },
};
